import "./_palier.scss";

import cx from "classnames";
import {useEffect, useState} from "react";

function Palier({
  paliers,
  current,
  typePalier,
}: {
  paliers?: number[];
  current?: number;
  typePalier?: string;
}): JSX.Element | undefined {
  const [responsiveScreen, setResponsiveScreen] = useState(
    window.innerWidth < 800,
  );
  useEffect(() => {
    // Fonction de gestion du redimensionnement
    const handleResize = (): void => {
      if (responsiveScreen !== window.innerWidth < 800) {
        setResponsiveScreen(window.innerWidth < 800);
      }
    };

    // Ajout de l'écouteur d'événement de redimensionnement
    window.addEventListener("resize", handleResize);

    // Suppression de l'écouteur d'événement lorsque le composant est démonté
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [responsiveScreen]); //
  const hasNoPalier = paliers?.length === 1 && paliers[0] === 1;
  const sortedPalier = paliers?.sort((a, b) => {
    return a - b;
  });
  if (sortedPalier && !hasNoPalier && current != undefined) {
    const progressionPourcentage = (
      value: number,
      maxValue: number,
    ): number => {
      const pourcentage: number = (value / maxValue) * 100;
      return pourcentage;
    };

    const responiveProgression = (pourcentage: number): number => {
      return 500 * (pourcentage / 100);
    };

    const objectifs = sortedPalier.map((palier, index): JSX.Element => {
      const pourcentageValueOfProgression = progressionPourcentage(
        palier,
        sortedPalier[sortedPalier.length - 1],
      );
      const marginLeft: string = `calc(${pourcentageValueOfProgression}% - 30px)`;

      const soonGood: boolean =
        progressionPourcentage(current, palier) >= 80 &&
        progressionPourcentage(current, palier) < 100;
      const marginTop: string = `calc(${responiveProgression(pourcentageValueOfProgression)}px )`;

      return (
        <div
          key={index}
          className={cx(
            "palier-circle",
            current >= palier && "palier-circle--atteint",
            soonGood && "palier-circle--proche",
          )}
          style={responsiveScreen ? {marginTop} : {marginLeft}}>
          <p>
            {new Intl.NumberFormat("fr-FR").format(palier)}
            {typePalier === "prix" ? "€" : ""}
          </p>
        </div>
      );
    });
    const progressBarWidth: number = progressionPourcentage(
      current,
      sortedPalier[sortedPalier.length - 1],
    );
    return (
      <div className="palier">
        <div
          className={cx("palier-progression", current === 0 && "hidden")}
          style={
            responsiveScreen
              ? {height: `${responiveProgression(progressBarWidth)}px`}
              : {width: `${progressBarWidth}%`}
          }></div>
        {objectifs}
      </div>
    );
  }
}

export default Palier;
